<template>
    <v-container flex grid-list-lg>
        <template v-if="!smartLock">
            <smart-lock-message></smart-lock-message>
        </template>
        <v-layout row wrap v-else>
            <v-flex xs12>
                <v-toolbar color="#eee" class="elevation-0 secondary--text">
                  <v-toolbar-title>Empresas</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-slide-x-transition>
                    <v-layout justify-end v-show="searchingPosto">
                      <v-flex xs1>
                        <v-tooltip bottom>
                          <v-btn
                            icon
                            color="info"
                            @click="carregarEmpresas(true)"
                            slot="activator"
                          >
                            <v-icon>search</v-icon>
                          </v-btn>
                          <span>Pesquisar</span>
                        </v-tooltip>
                      </v-flex>
                      <v-flex xs3>
                        <v-select
                          outline
                          hide-details
                          single-line
                          placeholder="Filtrar por"
                          :items="filtrosEmpresa"
                          item-value="value"
                          item-text="text"
                          v-model="filtro"
                        ></v-select>
                      </v-flex>
                      <v-flex xs4>
                        <v-text-field
                          v-if="filtro !== 'tipo_empresa'"
                          outline
                          hide-details
                          single-line
                          :readonly="!filtro"
                          :placeholder="filtro === 'cnpj' ? 'Insira o CNPJ' : 'Insira as informações'"
                          :mask="filtro === 'cnpj' ? '##.###.###/####-##' : ''"
                          v-model="campoPesquisa"
                        ></v-text-field>
                        <v-select
                          v-else
                          outline
                          hide-details
                          single-line
                          :readonly="!filtro"
                          :items="tipo_empresa"
                          placeholder="Selecione o tipo de empresa"
                          v-model="campoPesquisa"
                        ></v-select>
                    </v-flex>
                    </v-layout>
                  </v-slide-x-transition>
                  <v-btn icon color="info" @click="searchingPosto = !searchingPosto">
                    <v-icon v-if="!searchingPosto">search</v-icon>
                    <v-icon v-else>close</v-icon>
                  </v-btn>
                  <v-tooltip bottom>
                    <v-btn @click="dialogContrato = true" slot="activator" color="info" icon>
                      <v-icon>description</v-icon>
                    </v-btn>
                    <span>Contrato Padrão</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <v-btn icon color="info" slot="activator" @click="dialogCadEmpresa = true">
                      <v-icon>add</v-icon>
                    </v-btn>
                    <span>Cadastrar Nova Empresa</span>
                  </v-tooltip>
                </v-toolbar>
            </v-flex>
            <v-flex xs12>
                <v-data-table
                    :headers="empresaHeaders"
                    :items="empresas"
                    :loading="loading"
                    :pagination.sync="pagination"
                    :total-items="totalItems"
                    hide-actions
                >
                <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
                <template slot="headerCell" slot-scope="{ header }">
                    <span class="font-weight-light" v-text="header.text" />
                </template>
                <template slot="items" slot-scope="props">
                    <td>{{ props.item.nome_fantasia }}</td>
                    <td class="text-xs-left">{{ props.item.razao_social }}</td>
                    <td class="text-xs-left">{{ props.item.cnpj }}</td>
                    <td
                    class="text-xs-left"
                    ><span v-if="props.item.administrador"  v-html="`${props.item.administrador.nome} ${props.item.administrador.sobrenome}`"></span></td>
                    <td class="text-xs-left">
                        <v-btn flat icon v-if="props.item.ativo" color="green lighten-2">
                            <v-icon>check_circle</v-icon>ATIVA
                        </v-btn>

                        <v-btn flat icon v-else color="error">
                            <v-icon>cancel</v-icon>INATIVA
                        </v-btn>
                    </td>
                    <td class="text-xs-right">
                        <v-tooltip lazy v-if="props.item.ativo" bottom>
                            <v-btn icon color="red" slot="activator" flat @click="ativaOuDesativarEmpresa(props.item)">
                            <v-icon>close</v-icon>
                            </v-btn>Desativar Empresa
                        </v-tooltip>
                        <v-tooltip lazy v-else bottom>
                            <v-btn icon flat color="green" slot="activator" @click="ativaOuDesativarEmpresa(props.item)">
                            <v-icon>check</v-icon>
                            </v-btn>Ativar Empresa
                        </v-tooltip>
                    </td>
                    <td>
                        <v-tooltip lazy bottom>
                          <v-btn
                            slot="activator"
                            flat icon
                            :color="props.item.is_empresa_parceira ? 'success' : ''"
                            @click="dialogEmpresaParceira(props.item)"
                          >
                              <v-icon>handshake</v-icon>
                          </v-btn> {{!props.item.is_empresa_parceira ? 'Tornar Parceira' : 'Remover parceria'}}
                        </v-tooltip>
                        <v-tooltip lazy bottom v-if="props.item.is_empresa_parceira">
                        <v-btn
                          slot="activator"
                          flat
                          icon
                          color="info"
                          @click="abrirAtualizarEmpresaParceira(props.item)"
                        >
                          <v-icon>edit_note</v-icon>
                        </v-btn>
                        Atualizar informações da parceria
                      </v-tooltip>
                        <v-tooltip lazy bottom>
                          <v-btn slot="activator" flat icon color="info" @click="abrirEditar(props.item)">
                              <v-icon>edit</v-icon>
                          </v-btn> Editar dados da empresa
                        </v-tooltip>
                        <v-tooltip lazy bottom>
                          <v-btn slot="activator" flat icon color="primary" @click="abrirDetalhes(props.item)">
                              <v-icon>remove_red_eye</v-icon>
                          </v-btn> Visualizar dados da empresa
                        </v-tooltip>
                        <v-tooltip lazy bottom>
                        <v-btn
                          slot="activator"
                          flat
                          icon
                          color="primary"
                          @click="empresaSelecionada = props.item, dialogHistorico = true">
                          <v-icon>account_balance_wallet</v-icon>
                        </v-btn>
                          Visualizar Carteira Virtual
                      </v-tooltip>
                    </td>
                </template>
                </v-data-table>
                <div class="text-xs-center pt-2">
                    <v-pagination color="info" circle v-model="pagination.page" :length="pages"></v-pagination>
                </div>
            </v-flex>
        </v-layout>
        <v-dialog v-model="dialogDetalhes" v-if="dialogDetalhes" width="500">
            <detalhes-empresa @fechar="dialogDetalhes = false, empresaSelecionada = null" :empresa="empresaSelecionada"/>
        </v-dialog>
        <v-dialog v-model="dialogEditar" v-if="dialogEditar" width="500">
            <editar-empresa
              @success="showSuccess"
              @error="showError"
              @fechar="dialogEditar = false,
              empresaSelecionada = null"
              :empresa_selecionada="empresaSelecionada"
              @carregar="carregarEmpresas(false)"
            />
        </v-dialog>
        <v-dialog v-model="dialogContrato" v-if="dialogContrato" width="600" scrollable>
            <contrato-empresa @success="showSuccess" @error="showError" @fechar="dialogContrato = false"/>
        </v-dialog>
        <v-dialog v-model="dialogCadEmpresa" width="500">
          <cad-empresa @carregar="carregarEmpresas(false)" @success="showSuccess" @error="showError" @fechar="dialogCadEmpresa = false, empresaSelecionada = null" :empresaParceira="empresaSelecionada" v-if="dialogCadEmpresa"/>
        </v-dialog>
        <v-dialog v-model="dialogRemoverParceiria" v-if="dialogRemoverParceiria" width="500">
          <confirmacao-remocao @fechar="dialogRemoverParceiria = false, empresaSelecionada = null" @confirmar="removerParceiria"/>
        </v-dialog>
        <v-dialog
          v-model="dialogHistorico"
          v-if="dialogHistorico"
          width="500"
          scrollable
        >
          <historico-carteira
            :empresa="empresaSelecionada"
            @fechar="
              dialogHistorico = false,
              empresaSelecionada = undefined
            "
          />
        </v-dialog>
        <v-snackbar
          v-model="snackbar.active"
          :color="snackbar.color"
          :multi-line="snackbar.multiLine"
          :timeout="snackbar.timeout"
          :vertical="snackbar.vertical"
        >
          {{ snackbar.text }}
          <v-btn
            flat
            @click="snackbar.active = false"
          >
            Fechar
          </v-btn>
      </v-snackbar>
    </v-container>
</template>

<script>
import SmartLockMessage from '@/components/SmartLockMessage'
import DetalhesEmpresa from '@/components/dialogs/DetalhesEmpresa'
import EditarEmpresa from '@/components/dialogs/EditarEmpresa'
import ConfirmacaoRemocao from '@/components/dialogs/ConfirmacaoRemocao'
import ContratoEmpresa from '@/components/dialogs/ContratoEmpresa'
import CadEmpresa from '@/components/cadastros/CadEmpresa'
import HistoricoCarteira from '@/components/dialogs/HistoricoCarteira'

export default {
  components: {
    SmartLockMessage,
    DetalhesEmpresa,
    EditarEmpresa,
    ContratoEmpresa,
    CadEmpresa,
    ConfirmacaoRemocao,
    HistoricoCarteira
  },
  data () {
    return {
      dialogCadEmpresa: false,
      dialogContrato: false,
      dialogDetalhes: false,
      dialogEditar: false,
      dialogHistorico: false,
      dialogRemoverParceiria: false,
      primeiroCarregamento: false,
      empresaSelecionada: null,
      tipo_empresa: [
        { text: 'Controle de Frota', value: 1 },
        { text: 'Revendedora de veículos', value: 2 },
        { text: 'Automação', value: 3 },
        { text: 'Venda de Produtos', value: 4 },
        { text: 'Prestação de Serviços', value: 5 },
        { text: 'Venda de Produtos e Serviços', value: 6 },
        { text: 'Instituição Beneficente', value: 7 },
        { text: 'Integradora', value: 8 },
        { text: 'Sindicato', value: 9 }
      ],
      snackbar: {
        active: false,
        color: '',
        multiLine: true,
        timeout: 4000,
        vertical: true,
        text: ''
      },
      pagination: {
        rowsPerPage: 5,
        page: 1
      },
      empresaHeaders: [
      {
        text: 'Nome Fantasia',
        align: 'left',
        sortable: false,
        value: 'nome_fantasia'
      },
      { text: 'Razão social', sortable: false, value: 'razao_social' },
      { text: 'Cnpj', sortable: false, value: 'cnpj' },
      { text: 'Representante', sortable: false },
      { text: 'Status', sortable: false, value: 'ativo' },
      {
        sortable: false,
        align: 'right'
      },
      {
        sortable: false,
        align: 'right'
      }
      ],
      searchingPosto: false,
      filtrosEmpresa: [
        {
          value: 'cnpj',
          text: 'CNPJ'
        },
        {
          value: 'nome_fantasia',
          text: 'Nome Fantasia'
        },
        {
          value: 'tipo_empresa',
          text: 'Tipo de empresa'
        }
      ],
      campoPesquisa: '',
      filtro: ''
    }
  },
  computed: {
    smartLock () {
      return this.$store.getters.smartLock
    },
    empresas () {
      return this.$store.getters.empresas
    },
    loading () {
      return this.$store.getters.loading
    },
    totalItems () {
      return this.$store.getters.totalItemsEmpresas
    },
    headers () {
      return this.$store.getters.headers
    },
    pages () {
      if (this.pagination.rowsPerPage == null || this.totalItems == null) {
        return 0
      }

      return Math.ceil(this.totalItems / this.pagination.rowsPerPage)
    },
    searchData () {
      let tempData = {
        pagination: this.pagination,
        filtros: {}
      }
      if (this.campoPesquisa) {
        switch (this.filtro) {
          case 'cnpj':
            tempData.filtros['cnpj__icontains'] = this.campoPesquisa
            break
          case 'nome_fantasia':
            tempData.filtros['nome_fantasia__icontains'] = this.campoPesquisa
            break
          case 'tipo_empresa':
            tempData.filtros['tipo_empresa'] = this.campoPesquisa
            break
        }
      }
      return tempData
    }
  },
  methods: {
    carregarEmpresas (zerarPaginacao) {
        let tempData = {
          filtros: {}
        }
        if (zerarPaginacao) {
          this.pagination = {
            page: 1,
            rowsPerPage: this.pagination.rowsPerPage
          }
        }
        tempData.pagination = this.pagination
        if (this.campoPesquisa) {
          switch (this.filtro) {
            case 'cnpj':
              tempData.filtros['cnpj__icontains'] = this.campoPesquisa
              break
            case 'nome_fantasia':
              tempData.filtros['nome_fantasia__icontains'] = this.campoPesquisa
              break
            case 'tipo_empresa':
              tempData.filtros['tipo_empresa'] = this.campoPesquisa
              break
          }
        }
        this.$store.dispatch('getEmpresas', tempData).then(() => {
          this.primeiroCarregamento = true
        })
    },
    ativaOuDesativarEmpresa (empresa) {
        this.$store.dispatch('ativarOuDesativarEmpresa', empresa.cnpj).then(() => {
            this.carregarEmpresas(false)
        })
    },
    abrirDetalhes (empresa) {
        this.empresaSelecionada = empresa
        this.dialogDetalhes = true
    },
    abrirEditar (empresa) {
        this.empresaSelecionada = empresa
        this.dialogEditar = true
    },
    showSuccess (text) {
      this.snackbar.color = 'primary'
      this.snackbar.text = text
      this.snackbar.active = true
    },
    showError (text) {
      this.snackbar.color = 'error'
      this.snackbar.text = text
      this.snackbar.active = true
    },
    abrirAtualizarEmpresaParceira (empresa) {
    this.empresaSelecionada = empresa
    this.dialogCadEmpresa = true
   },
    dialogEmpresaParceira (empresa) {
      this.empresaSelecionada = empresa
      if (!empresa.is_empresa_parceira) {
        this.dialogCadEmpresa = true
      } else {
        this.dialogRemoverParceiria = true
      }
    },
    removerParceiria () {
      const data = { ...this.empresaSelecionada }
      data.is_empresa_parceira = false
      data.contato2 = this.empresaSelecionada.contato2 ? this.empresaSelecionada.contato2 : null
      data.contato3 = this.empresaSelecionada.contato3 ? this.empresaSelecionada.contato3 : null
      data.url_logo = this.empresaSelecionada.url_logo ? this.empresaSelecionada.url_logo : null
      data.url_banner = this.empresaSelecionada.url_banner ? this.empresaSelecionada.url_banner : null
      this.$store.dispatch('tornarParceira', data).then(() => {
          this.showSuccess('Essa empresa não é mais uma parceira')
          this.carregarEmpresas(false)
          this.empresaSelecionada = null
          this.dialogRemoverParceiria = false
      })
    }
  },
  watch: {
    'pagination.page' (val) {
      if (val && this.primeiroCarregamento) {
        this.carregarEmpresas(false)
      }
    },
    searchingPosto (val) {
      if (!val) {
        this.filtro = ''
        this.campoPesquisa = ''
      }
    }
  }
}
</script>
